module.exports = __webpack_public_path__ + "static/media/down.45c7da71.svg";